import { render, staticRenderFns } from "./PartnerInfoDialog.vue?vue&type=template&id=5137afc4&"
import script from "./PartnerInfoDialog.vue?vue&type=script&lang=js&"
export * from "./PartnerInfoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports